import { render, staticRenderFns } from "./position-size-calculator.vue?vue&type=template&id=c6d27630&scoped=true"
import script from "./position-size-calculator.vue?vue&type=script&lang=js"
export * from "./position-size-calculator.vue?vue&type=script&lang=js"
import style0 from "./position-size-calculator.vue?vue&type=style&index=0&id=c6d27630&prod&lang=css"
import style1 from "./position-size-calculator.vue?vue&type=style&index=1&id=c6d27630&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6d27630",
  null
  
)

export default component.exports